document.addEventListener('alpine:init', () => {
  Alpine.data('countryListTrimmed', () => ({
    visible: [],
    rest: [],
    maxLength: 0,
    expanded: false,
    alt: '',

    init() {
      this.maxLength = +this.$root.dataset.maxLength;

      this.$nextTick(() => {
        const alt = this.$refs.data.textContent.trim();

        if (alt === '-') {
          this.alt = '-';
          return;
        }

        const els = [...this.$refs.data.querySelectorAll('*')];
        let c = 0;

        do {
          const el = els.shift();
          c += el.textContent.trim().length;
          this.visible.push(el.outerHTML);

          if (c > this.maxLength) {
            break;
          }
        } while (els.length);

        this.rest.push(...els.map((el) => el.outerHTML));
      });
    },
  }));
});